<template>
  <v-dialog v-model="openModal" persistent scrollable width="900">
    <v-card>
      <v-card-title>
        <span>
          {{ $t('checkout') }}
        </span>
        <!-- <span v-if="step == 2 && !error && !profileCancel">{{ $t('upgrade.modal.check_out') }}</span>
        <span v-if="step == 2 && !error && !profileCancel">
          {{ downgrade ? $t('upgrade.modal.changed_plan_title') : $t('upgrade.modal.upgrade_success') }}
        </span>
        <span v-if="error">{{ $t('upgrade.modal.error') }}</span>
        <span v-if="profileCancel && downgrade && !error">{{ step == 2 ? $t('profile.subscription.canseled_subscription') :
          $t('profile.subscription.cancel_subscription') }}</span> -->

        <v-spacer></v-spacer>

        <!-- Header-level Cancel for billing substep -->
        <v-btn
          v-if="step === 0 && !hasPaidPlan && firstPaymentSubstep === 'billing' && !error && !loading"
          text
          class="header-cancel"
          @click="firstPaymentSubstep = 'method'">
          {{ $t('cancel') }}
        </v-btn>
      </v-card-title>
      <v-card-text v-if="profileDowngrade">
        <div class="upgrade-confirmation">
          <!-- <p class="text"
            v-html="$t('profile.subscription.cancel_text', { planName: downgradedPlan, planDate: formatDate(currentPlan?.valid_to, true), curentPlanName: getPlanName(currentPlan?.id), curentPlanDate: formatDate(currentPlan?.valid_to) })">
          </p> -->
        </div>
      </v-card-text>
      <v-card-text v-else>
        <div v-if="step === 0 && !error && !hasPaidPlan && firstPaymentSubstep === 'method'" class="payment-method-selection">
          <div class="payment-selection-wrapper text-center">
            <h3 class="my-4">{{ $t('please_select_payment_method')}}</h3>
            <div class="button-container">
              <v-btn
                color="primary"
                :outlined="paymentMethod !== 'online'"
                :class="{ 'selected-btn': paymentMethod === 'online' }"
                @click="paymentMethod = 'online'">
                {{ $t('pay_online')}}
              </v-btn>
              <span class="mx-3">{{ $t('or') }}</span>
              <v-btn
                :disabled="!isYearlyPayment"
                color="primary"
                :outlined="paymentMethod !== 'wire'"
                :class="{ 'selected-btn': paymentMethod === 'wire' }"
                @click="paymentMethod = 'wire'">
                {{ $t('wire_transfer')}}
              </v-btn>
            </div>
            <div v-if="!isYearlyPayment" class="mt-3">
              {{ $t('wire_transfer_only_available_for_yearly_payments')}}
            </div>
          </div>
        </div>

        <!-- First-payment: billing-info substep -->
        <div v-else-if="step === 0 && !error && !hasPaidPlan && firstPaymentSubstep === 'billing'" class="billing-info-step">
          <div class="billing-info-header">
            <div class="billing-info-title">{{ $t('checkout_view.get_invoice_title') }}</div>
            <div class="billing-info-subtitle">{{ $t('checkout_view.get_invoice_subtitle') }}</div>
          </div>
          <billing-customer ref="billing-customer-form" :customer="customer"></billing-customer>
          <billing-business ref="billing-business-form" :country="prefillAddress.country_code || ''" :business="prefillBusiness"></billing-business>
          <h3 class="address-heading">{{ $t('address') }}</h3>
          <billing-address is-checkout ref="billing-address-form" :address="prefillAddress"></billing-address>

          <template v-if="paymentMethod === 'wire'">
            <h3 class="address-heading">{{ $t('checkout_view.discount_heading') }}</h3>
            <v-text-field
              :label="$t('checkout_view.discount_code')"
              v-model="couponCode"
              small dense outlined
              :error-messages="couponErrors"
              @input="couponErrors = []"
            ></v-text-field>
          </template>

          <div class="billing-info-primary-action">
            <v-btn
              color="primary"
              class="raised"
              :loading="loading"
              @click="saveAndCheckout()">
              {{ $t('checkout_view.save_and_checkout') }}
            </v-btn>
          </div>

          <template v-if="paymentMethod === 'online'">
            <div class="billing-info-divider">
              <span class="divider-line"></span>
              <span class="divider-label">{{ $t('or') }}</span>
              <span class="divider-line"></span>
            </div>
            <div class="skip-invoice-section">
              <div class="skip-invoice-text">
                <div class="skip-invoice-title">{{ $t('checkout_view.no_invoice_needed_title') }}</div>
                <div class="skip-invoice-subtitle">{{ $t('checkout_view.no_invoice_needed_subtitle') }}</div>
              </div>
              <v-btn
                color="primary"
                outlined
                :disabled="loading"
                @click="skipInvoiceAndCheckout()">
                {{ $t('checkout') }}
              </v-btn>
            </div>
          </template>
        </div>

        <div v-if="step == 1" class="upgrade-confirmation">
          <div class="w-100">
            <div class="ma-auto text-center" v-if="isPaddleCheckoutOpen">
              <v-progress-circular size="50" indeterminate color="primary"></v-progress-circular>
            </div>
            <div v-else>
              {{ $t('proceed_to_checkout') }}
            </div>
          </div>
        </div>
        <div v-if="step == 2 && !checkoutError" class="success-ctn pt-5">
          <success-icon></success-icon>
          <v-col justify="center" align="center">
            <span v-if="paymentMethod === 'online'" v-html="$t('payment_processed_successfully')"></span>
            <span v-else v-html="$t('wire_transfer_successfull_check_email')"></span>
          </v-col>
        </div>
        <div v-if="checkoutError" class="success-ctn">
          <error-icon></error-icon>
          <div>
            <p>
              {{ $t('payment_error') }} <br>
            </p>
            <p class="error-message">
              {{ checkoutError && checkoutError !== null ? `(${checkoutError})` : '' }}
            </p>
            <p>
              {{ $t('contact_support_for_help') }}
            </p>
            <!-- <p v-if="updatePayment">
              <update-payment-method :label="$t('card_issue')"></update-payment-method>
            </p> -->
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
         <!-- Close/Cancel button -->
        <v-btn v-if="!(step === 0 && !hasPaidPlan && firstPaymentSubstep === 'billing' && !error && !loading)" text @click="close()">
          {{ $t('close') }}
        </v-btn>

        <!-- Payment method selection action bar -->
        <!-- <div v-if="step === 0 && isWireTransfer !== null">
          <v-btn color="primary" class="raised" v-if="step === 0" :loading="loading" @click="confirmPaymentSelection()">
            {{ $t('confirm') }}
          </v-btn>
        </div> -->

        <div v-if="step === 1">
          <v-btn color="primary" class="raised ml-5"  @click="confirm()">
            {{ $t('checkout') }}
          </v-btn>
        </div>

        <v-btn
          v-else-if="!paddleLoaded && !profileDowngrade && step !== 2 && !loading && !(step === 0 && !hasPaidPlan && firstPaymentSubstep === 'billing')"
          color="primary"
          class="ml-5 raised"
          :disabled="step === 0 && !hasPaidPlan && firstPaymentSubstep === 'method' && paymentMethod === null"
          @click="handlePrimaryAction()"
          :loading="loading">
          {{ primaryActionLabel }}
        </v-btn>

        <!-- <v-btn text @click="close()">
          {{ step == 2 || (error && (profile.role !== 'elabel' && profile.role !== 'elabel_enterprise')) ? $t('close') : $t('cancel') }}
        </v-btn>
        <v-btn v-if="profileDowngrade" color="primary" class="raised" @click="$emit('profileDowngrade')">
          {{ $t('continue')}}
        </v-btn>

        <div class="ml-5" v-if="!paddleLoaded && !profileDowngrade">
          <v-btn
            v-if="!success && (checkout || downgrade || currentPlan?.id === 'st-pro-free' || selectedPlan?.id === 'st-pro-free')"
            color="primary" class="raised" @click="confirm()" :loading="loading">
            {{ error ? $t('upgrade.modal.button_try') : $t('button_confirm') }}
          </v-btn>
          <v-btn
            v-if="!success && !downgrade && !checkout && currentPlan?.id !== 'st-pro-free' && selectedPlan?.id !== 'st-pro-free'"
            color="primary" class="raised" @click="upgradePlan(selectedPlan?.productID)" :loading="loading">
            {{ error ? $t('upgrade.modal.button_try') : $t('button_confirm') }}
          </v-btn>
        </div> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* global Paddle */
import Api from '@/api'
import Utils from '@/utils/utils'
import amplitude from 'amplitude-js'
import SuccessIcon from '@/components/icons/Success'
import ErrorIcon from '@/components/icons/Error'
import { mapGetters } from 'vuex'
import Plans from '@/const/plans'
import BillingBusiness from '@/components/forms/BillingBusiness'
import BillingAddress from '@/components/forms/BillingAddress'
import BillingCustomer from '@/components/forms/BillingCustomer'

export default {
  name: 'CheckoutDialog',
  props: [
    'downgradedPlan', 'profileCancel', 'profileDowngrade', 'openModal',
    'selectedPlan', 'downgrade', 'directCheckout', 'prices', 'contract', 'isYearlyPayment'
  ],
  components: {
    ErrorIcon,
    SuccessIcon,
    BillingBusiness,
    BillingAddress,
    BillingCustomer
  },
  data () {
    return {
      step: 0,
      plans: Api.paddle_plans,
      planPrice: {},
      countrySearch: '',
      paymentFullfilled: false,
      checkoutError: null,
      isPaddleCheckoutOpen: false,
      hasSubmittedBusinessInfo: false,
      selectedAddress: null,
      loading: false,
      firstPaymentSubstep: 'method',
      paymentMethod: null,
      paddleLoaded: false,
      error: false,
      lastCheckoutPrefill: null,
      couponCode: '',
      couponErrors: []
    }
  },
  computed: {
    ...mapGetters(['currentPlan', 'profile', 'association', 'customerBusiness', 'customerAddresses', 'customer', 'subscriptionAddress', 'subscriptionBusiness']),

    prefillAddress () {
      return this.subscriptionAddress || this.customerAddresses[0] || {}
    },

    prefillBusiness () {
      return this.subscriptionBusiness || this.customerBusiness || {}
    },

    hasPaidPlan () {
      return this.currentPlan.id.indexOf('st-pro-free') === -1 && this.currentPlan.id.indexOf('st-pro-trial') === -1
    },

    primaryActionLabel () {
      if (this.step === 0 && !this.hasPaidPlan && this.firstPaymentSubstep === 'method') {
        return this.$t('continue')
      }
      // When we add downgrade
      // return this.isDowngradeFlow ? this.$t('upgrade.modal.confirm_downgrade') : this.$t('checkout')
      return this.$t('checkout')
    },

    getElabelQuantity () {
      if (this.currentPlan?.id === 'st-pro-free') {
        return this.currentPlan?.definition['workorder:initial_quantity']
      } else if (this.currentPlan?.id === 'elabel-premium') {
        return this.$t('upgrade.unlimited')
      } else {
        return this.currentPlan?.definition['workorder:recurring_quantity']
      }
    },
    currentDate () {
      const date = new Date()
      return Utils.formatDate(date)
    }
  },
  created () {
    if (this.directCheckout) {
      this.$nextTick(() => {
        this.buyPlan(this.selectedPlan?.productID)
      })
    }
  },
  methods: {
    handlePrimaryAction () {
      if (this.step === 0 && !this.hasPaidPlan && this.firstPaymentSubstep === 'method') {
        this.firstPaymentSubstep = 'billing'
        return
      }
      this.confirm()
    },

    eventHandler (event) {
      console.log('event handler', event)

      if (event.name === 'checkout.loaded') {
        this.$set(this.planPrice, 'total', event.data.recurring_totals.total)
        this.$set(this.planPrice, 'discount', event.data.recurring_totals.discount)
        this.$set(this.planPrice, 'tax', event.data.recurring_totals.tax)
      }

      if (event.name === 'checkout.completed') {
        if (event.data.status === 'completed' || event.data.status === 'paid') {
          this.step = 2
          this.paymentFullfilled = true
          Paddle.Checkout.close()
        }
      }

      if (event.name === 'checkout.closed') {
        this.loading = false
        if (event.data.status === 'completed' || event.data.status === 'paid') {
          this.step = 2
          this.paymentFullfilled = true
        } else {
          this.isPaddleCheckoutOpen = false
        }
      }

      if (event.name === 'checkout.error') {
        this.checkoutError = `Error code ${event.error?.code}:, ${event.error?.detail}`
      }

      // const eventPrice = data.eventData?.checkout.prices.customer
      // const showPricesWithDiscount = () => {
      //   const eventPrices = data.eventData?.checkout.prices.customer
      //   const totalPriceWithDiscount = Number.parseFloat(eventPrices.total)
      //   const total = totalPriceWithDiscount.toLocaleString(undefined, {
      //     minimumFractionDigits: 2,
      //     maximumFractionDigits: 2
      //   })
      //   const discount = ((Number.parseFloat(eventPrices.unit) - totalPriceWithDiscount) - (eventPrices.unit_tax - eventPrices.total_tax)).toFixed(2)

      //   this.customerPrice.total = total
      //   this.customerPrice.discount = discount
      //   this.customerPrice.total_tax = eventPrices.total_tax
      // }
      // if (data.event === 'Checkout.Customer.Details' && this.profile.company.association) {
      //   showPricesWithDiscount()
      // }
      // if (data.event === 'Checkout.Location.Submit') {
      //   this.subscribe = true
      //   this.customerPrice.total = eventPrice.total
      //   this.customerPrice.total_tax = eventPrice.total_tax
      // }
      // if (data.event === 'Checkout.Coupon.Applied') {
      //   this.couponCode = data.eventData?.coupon ? data.eventData?.coupon?.coupon_code : data.eventData?.checkout?.coupon.coupon_code

      //   showPricesWithDiscount()
      // } else if (data.event === 'Checkout.Coupon.Remove') {
      //   this.couponCode = ''
      //   this.customerPrice.total = eventPrice.total
      //   this.customerPrice.total_tax = eventPrice.total_tax
      //   delete this.customerPrice.discount
      // }
      // if (data.event === 'Checkout.PaymentComplete') {
      //   this.upgraded = true
      // }
      // if (data.event === 'Checkout.Complete') {
      //   this.subscribe = false
      //   this.step = 2
      //   this.upgraded = false
      //   this.success = true
      //   this.$emit('checkout-complete')
      // }
    },
    getPlanPrice (planId, billingCycle = 'month') {
      return this.prices[planId][billingCycle] || 0
    },
    getPlanName (planId) {
      // return this.plans.find(p => p.id === planId).name
      return Plans.find(p => p.id === planId)?.name || ''
      // return 'plan name: ' + planId
    },
    addDays (date, days) {
      const res = new Date(date)
      res.setDate(res.getDate() + days)
      return res
    },
    formatDate (date, extraDay, addYear) {
      const setDate = extraDay ? this.addDays(date, 1) : date
      return Utils.formatDate(setDate, true, addYear)
    },
    close () {
      this.$emit('close', this.paymentFullfilled)
      // this.loading = false
      // this.errorMessage = null
      // this.checkout = false
      // this.paddleLoaded = false
      // this.updatePayment = false
      // this.subscribe = false
      // this.success = false
      // this.unsuccessfulPayment = this.unsuccessfulPayment ?? false
      // this.error = false
    },
    // getProductPrice (productID) {
    //   Paddle.Product.Prices(productID, (data) => {
    //     const price = {
    //       total: data.price.gross.substring(1),
    //       price: data.price.net.substring(1),
    //       total_tax: data.price.tax.substring(1)
    //     }
    //     this.customerPrice = price
    //   })
    // },

    buyPlan (priceID, { customerId, addressId, businessId } = {}) {
      const companyID = this.profile.company.id
      this.loading = true
      this.isPaddleCheckoutOpen = true
      this.step = 1
      this.lastCheckoutPrefill = { priceID, customerId, addressId, businessId }

      const customer = {}
      if (customerId) {
        customer.id = customerId
        if (addressId) customer.address = { id: addressId }
        if (businessId) customer.business = { id: businessId }
      } else {
        customer.email = this.profile?.email
      }

      try {
        Paddle.Checkout.open({
          items: [{ priceId: priceID, quantity: 1 }],
          customData: {
            company_id: companyID
          },
          allowQuantity: false,
          settings: {
            theme: 'light',
            displayMode: 'overlay',
            variant: 'one-page'
          },
          customer
        })
        this.paddleLoaded = true
      } catch (error) {
        console.error(`Checkout error: ${error.message}`)
        this.handleError(error)
      }
    },

    // async updatePlan (planID) {
    //   this.loading = true
    //   if (!this.downgrade) {
    //     this.step = 2
    //   }
    //   if (planID === 'st-pro-free') {
    //     try {
    //       await this.$store.dispatch('cancelPlan')
    //       this.step = 2
    //       this.success = true
    //     } catch (error) {
    //       this.error = true
    //       this.errorMessage = error.response.data.detail
    //     }
    //   } else {
    //     try {
    //       amplitude.getInstance().logEvent('Confirm upgrade', { plan: this.selectedPlan.id })
    //       this.error = false
    //       await this.$store.dispatch('updatePlan', { plan: planID })
    //       this.step = 2
    //       this.checkout = false
    //       this.success = true
    //     } catch (error) {
    //       this.checkout = true
    //       this.error = true
    //       if (error.response?.data?.error_code) {
    //         if (error.response.data.error_code.indexOf('payment.paddle.') === 0) {
    //           const code = parseInt(error.response.data.error_code.split('payment.paddle.')[1])
    //           this.errorMessage = error.response.data.error_message
    //           // issue with card probably
    //           if (code === 147) {
    //             this.updatePayment = true
    //           }
    //         }
    //       } else {
    //         this.errorMessage = error.response.data.detail
    //       }
    //     }
    //   }
    //   this.loading = false
    // },
    // upgradePlan (productID) {
    //   if (!this.downgrade) {
    //     this.checkout = true
    //     if (!this.error) {
    //       this.step = 2
    //     }
    //   }
    //   this.getProductPrice(productID)
    // },

    async submitBillingForms () {
      await this.$nextTick()

      const validations = [
        this.$refs['billing-address-form'].validate(),
        this.$refs['billing-business-form'].validate(),
        this.$refs['billing-customer-form'].validate()
      ]

      if (validations.some(v => !v)) {
        throw new Error('Invalid billing forms')
      }

      const [addressResult, businessResult, customerResult] = await Promise.allSettled([
        this.$refs['billing-address-form'].submit(),
        this.$refs['billing-business-form'].submit(),
        this.$refs['billing-customer-form'].submit()
      ])

      // If a save failed, pass the real error up so saveAndCheckout
      // can show the backend's message to the user
      const firstRejectedSubmit = [addressResult, businessResult, customerResult].find(result => result.status === 'rejected')
      if (firstRejectedSubmit) {
        throw firstRejectedSubmit.reason
      }

      if (!businessResult.value || !addressResult.value || !customerResult.value) {
        throw new Error('Incomplete billing form responses')
      }

      return {
        addressResponse: addressResult.value,
        businessResponse: businessResult.value,
        customerResponse: customerResult.value
      }
    },

    async saveAndCheckout () {
      this.loading = true
      this.checkoutError = null
      let forms
      try {
        forms = await this.submitBillingForms()
      } catch (error) {
        console.log('ERROR _>', error)
        const responseData = error.response?.data
        if (responseData?.error_message && !responseData.field_errors?.length) {
          this.checkoutError = responseData.error_message
        }
        this.loading = false
        return
      }

      const { addressResponse, businessResponse } = forms

      if (this.paymentMethod === 'wire') {
        try {
          await this.$store.dispatch('requestInvoice', {
            addressId: addressResponse.id,
            businessId: businessResponse.id,
            priceId: this.selectedPlan?.price?.id,
            couponCode: this.couponCode.trim()
          })
          this.step = 2
          this.paymentFullfilled = true
        } catch (error) {
          console.log('error invoice', error)
          const fieldErrors = Utils.parseFieldErrors(error.response?.data)
          if (fieldErrors.coupon_code) {
            this.couponErrors = fieldErrors.coupon_code
          } else {
            this.checkoutError = error.response?.data?.error_message || error.message
          }
        } finally {
          this.loading = false
        }
        return
      }

      // Pay online with invoice info: pre-fill Paddle via IDs
      const priceID = this.selectedPlan?.price?.id
      amplitude.getInstance().logEvent('Click select plan', { plan: this.selectedPlan.id })
      this.buyPlan(priceID, {
        customerId: this.profile?.company?.external_id,
        addressId: addressResponse.id,
        businessId: businessResponse.id
      })
    },

    skipInvoiceAndCheckout () {
      const priceID = this.selectedPlan?.price?.id
      amplitude.getInstance().logEvent('Click select plan', { plan: this.selectedPlan.id })
      this.buyPlan(priceID, { customerId: this.profile?.company?.external_id })
    },

    async confirm () {
      // Re-open Paddle with the same pre-fill after the overlay was closed without completion
      if (this.step === 1 && this.lastCheckoutPrefill) {
        const { priceID, customerId, addressId, businessId } = this.lastCheckoutPrefill
        this.buyPlan(priceID, { customerId, addressId, businessId })
        return
      }

      if (this.currentPlan?.id === 'st-pro-free') {
        const productID = this.selectedPlan?.productID
        amplitude.getInstance().logEvent('Click select plan', { plan: this.selectedPlan.id })
        this.buyPlan(productID)
      } else {
        const planID = this.selectedPlan?.id
        amplitude.getInstance().logEvent('Click upgrade', { plan: planID })
        // this.updatePlan(planID)
      }
    }
  },
  mounted () {
    if (this.customerAddresses.length === 1) {
      this.selectedAddress = this.customerAddresses[0]
    }
    // If free plan, we go directly to checkout. No need to current plan vs new plan details
    // if (this.currentPlan?.id === 'st-pro-free') {
    //   this.confirm()
    // }
  }
}
</script>

<style lang="sass" scoped>
@import "@/variables.sass"

.billing-info-step
  padding: 0 8px

  .address-heading
    font-size: 16px
    font-weight: 700
    color: black
    text-align: left
    letter-spacing: 0.2px
    margin: 8px 0

  .billing-info-header
    margin-bottom: 18px

  .billing-info-title
    font-size: 18px
    font-weight: 700
    color: black
    margin-bottom: 6px

  .billing-info-subtitle
    font-size: 14px
    color: #777

  .billing-info-primary-action
    display: flex
    justify-content: flex-end
    margin-top: 8px

  .billing-info-divider
    display: flex
    align-items: center
    margin: 20px 0
    gap: 12px

    .divider-line
      flex: 1
      height: 1px
      background: rgba(0, 0, 0, 0.1)

    .divider-label
      color: #777
      font-size: 14px

  .skip-invoice-section
    display: flex
    align-items: center
    justify-content: space-between
    gap: 16px
    padding: 5px 0

    .skip-invoice-text
      flex: 1
      display: flex
      flex-direction: column
      gap: 6px

    .skip-invoice-title
      font-size: 18px
      font-weight: 700
      color: black

    .skip-invoice-subtitle
      font-size: 14px
      color: #777

.header-text
  color: #242424
  font-size: 26px
  font-style: normal
  font-weight: 500
  line-height: 24px

.payment-method-selection-wrapper
  margin: 20px auto
  max-width: 500px

  .button-container
    display: flex
    align-items: center
    justify-content: center
    flex-wrap: wrap

    .selected-btn
      background-color: $primary
      color: white
      box-shadow: none !important

    .v-btn
      &:focus::before
        opacity: 0

.text
  font-size: 16px
  color: black
  a
    color: black !important
    text-decoration: underline
.upgrade-confirmation
  display: flex
  padding: 20px 6px
  gap: 10px
  .current-plan
    padding: 20px
    background-color: #F3F3F3
    min-width: 240px
    color: #323232
    &-label
      padding: 0 4px
      background-color: #5D5D5D
      color: white
      font-size: 12px
    &-name
      font-weight: 400
      margin-bottom: 40px
    &-price
      font-size: 26px
      font-weight: 400
      &-info
        display: flex
        justify-content: space-between
      &-total-text
        float: right
        font-size: 12px
  .new-plan
    width: 100%
    padding: 20px 30px
    background-color: #E6F6FD
    color: black
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 3px 5px 0px rgba(0, 0, 0, 0.20)
    &-label
      @extend .current-plan-label
      background-color: #15BBF0
    .downgrade-color
      background-color: #F22A42
    &-subtext
      font-size: 12px
      text-align: left
      margin-bottom: 20px
    &-price
      display: flex
      justify-content: space-between
      &-amount
        display: flex
        flex-direction: column
        font-size: 26px
        font-weight: 700
        span:last-child:not(span:nth-child(1))
          font-size: 12px
          font-weight: 400
      &-e-labels
        @extend .new-plan-price-amount
        span
          text-align: right
    &-description
      text-align: center
      font-size: 14px
      font-weight: 400
      margin-bottom: 0
    .divider
      border: 2px solid white
      margin: 20px auto
    .downgrade-plan
      .mt
        margin-top: 20px
      p
        margin-bottom: 0

.checkout-container
  display: flex
  justify-content: space-between
  padding: 15px 0 0
  .checkout-container-paddle
    flex: 1
  .card-container
    flex: 1
    padding: 25px 30px
    text-align: center
    color: black
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    p
      text-align: left
      margin-top: 17px
      font-size: 16px
      font-weight: 400
  .price-container
    flex: 1
    background-color: blue
    padding: 25px 30px
    margin-bottom: 10px
    .price-content
      height: auto
    .upgraded
      display: flex
      align-items: center
      justify-content: space-between
      font-size: 18px
      color: black
    .main-logo
      max-width: 250px
      height: 32px
    .plan-name
      font-size: 24px
      color: #222222
      margin: 60px auto 40px
      font-weight: 700
    .total-price
      color: #222222
      .price-section > div
        display: flex
        justify-content: space-between
        font-size: 16px
        font-weight: 400
        margin-bottom: 30px
        .vat-text
          font-size: 12px
      .total
        display: flex
        justify-content: space-between
        font-size: 24px
        font-weight: 700
        padding: 25px 0
        border-top: 1px solid white
.success-ctn
  text-align: center
  font-size: 18px
  color: black
  line-height: 1.5
  img
    margin: 40px auto 30px
.error-message
  font-size: 12px
  color: #777777

</style>
